import { AxiosRequestConfig } from 'axios'
import { ROUTES } from 'constants/routesConstants'

import { getApiClient } from '@/api'
import { API_ROUTES } from '@/constants'
import { matchPathname } from '@/utils'

type TCheckoutPage = 'checkout' | 'checkout-plans'

// qr-api reports it as checkout_page on PostHog subscription events
export const getCheckoutPage = (
	pathname: string,
): TCheckoutPage | undefined => {
	if (matchPathname(pathname, ROUTES.checkout.index).match) return 'checkout'
	if (matchPathname(pathname, ROUTES.checkout.plans).match)
		return 'checkout-plans'
	return undefined
}

export const saveCheckoutMetadata = async (): Promise<void> => {
	if (typeof window === 'undefined') return

	const checkoutPage = getCheckoutPage(window.location.pathname)

	try {
		await getApiClient().post(
			API_ROUTES.subscription.checkoutMetadata,
			{ ...(checkoutPage && { checkoutPage }) },
			{ shouldShowErrorNotification: false } as AxiosRequestConfig,
		)
	} catch (error) {
		// Attribution is never worth failing a checkout over.
		console.error('Error saving checkout metadata:', error)
	}
}
